var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSoil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1261)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.25 42.7578H43.185L35.163 28.7208C34.8656 28.2008 34.4361 27.7685 33.918 27.4677C33.3999 27.1669 32.8116 27.0083 32.2125 27.0078H30.753C29.853 27.0078 28.968 26.8383 28.134 26.5038L27.294 26.1663C26.4179 25.8189 25.4936 25.6079 24.5535 25.5408C24.768 25.1493 25.0125 24.6633 25.266 24.0993C26.061 23.3208 27.084 22.9893 28.476 22.5663C29.9535 23.2263 31.2915 23.5713 32.472 23.5713C33.171 23.5713 33.816 23.4543 34.404 23.2248C36.369 22.4538 37.089 20.6493 37.362 19.9713L37.422 19.8213C37.503 19.6407 37.5098 19.4354 37.4411 19.2497C37.3724 19.0641 37.2336 18.9128 37.0545 18.8283L36.924 18.7578C34.83 17.6373 32.955 17.3448 31.344 17.8878C29.928 18.3633 28.791 19.4703 27.954 21.1578C27.294 21.3588 26.694 21.5508 26.1375 21.7848C26.3535 21.0873 26.547 20.3328 26.697 19.5288C26.7135 19.4823 26.739 19.4388 26.7465 19.3878C26.757 19.3413 26.7465 19.2978 26.745 19.2498C26.9625 17.9568 27.06 16.5423 26.943 15.0573C27.846 15.2283 28.698 15.3138 29.5005 15.3138C31.212 15.3138 32.6925 14.9283 33.9255 14.1573C35.7135 13.0368 36.897 11.1588 37.446 8.57733L37.476 8.43183C37.4996 8.33586 37.5038 8.23616 37.4884 8.13855C37.473 8.04094 37.4383 7.94737 37.3864 7.86331C37.3344 7.77924 37.2663 7.70637 37.1858 7.64894C37.1054 7.59152 37.0144 7.55068 36.918 7.52883C36.051 7.32483 29.166 5.91333 26.259 11.5083C25.882 10.3249 25.3738 9.18734 24.744 8.11683C24.717 5.70933 23.988 3.78183 22.569 2.39583C21.4035 1.25583 19.164 -0.0911703 15.1215 0.00482967L15 0.00782967C14.8011 0.00782967 14.6103 0.0868473 14.4697 0.2275C14.329 0.368152 14.25 0.558917 14.25 0.75783L14.247 0.91233C14.226 1.79283 14.1615 4.47483 16.203 6.53883C17.784 8.14383 20.25 8.96583 23.523 9.00333C24.451 10.6003 25.075 12.3555 25.3635 14.1798V14.2218L25.374 14.2548C25.479 14.9598 25.5285 15.6498 25.53 16.3173C25.1033 15.7221 24.5629 15.2174 23.94 14.8323C22.374 13.8783 20.2215 13.6818 17.8785 14.2878L17.814 14.3043C17.623 14.3507 17.4578 14.4702 17.354 14.6371C17.2502 14.804 17.2161 15.005 17.259 15.1968L17.283 15.3048C17.433 16.0323 17.886 18.2373 19.929 19.5138C20.8665 20.1003 21.999 20.3928 23.307 20.3928C23.859 20.3928 24.447 20.3343 25.062 20.2323C24.777 21.3963 24.402 22.4223 24.027 23.2713C24.0004 23.3172 23.9792 23.366 23.964 23.4168C23.6413 24.1387 23.2689 24.8374 22.8495 25.5078H22.167C21.186 25.5078 20.262 26.0298 19.758 26.8728L18.3255 29.2578H16.0215C15.141 29.2578 14.3085 29.6868 13.7955 30.4038L11.6925 33.3438C11.4362 33.7033 11.0978 33.9965 10.7054 34.1989C10.313 34.4014 9.87802 34.5073 9.4365 34.5078C7.9665 34.5078 6.6165 35.2488 5.829 36.4878L1.8375 42.7578H0.75C0.551088 42.7578 0.360322 42.8368 0.21967 42.9775C0.0790176 43.1182 0 43.3089 0 43.5078C0 43.7067 0.0790176 43.8975 0.21967 44.0382C0.360322 44.1788 0.551088 44.2578 0.75 44.2578H44.25C44.4489 44.2578 44.6397 44.1788 44.7803 44.0382C44.921 43.8975 45 43.7067 45 43.5078C45 43.3089 44.921 43.1182 44.7803 42.9775C44.6397 42.8368 44.4489 42.7578 44.25 42.7578Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_1261",
    x: -20,
    y: -15,
    width: 85,
    height: 84.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.317647 0 0 0 0 0.356863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSoil);
export default __webpack_public_path__ + "static/media/ic-soil.e1cfeaf655e6d3a20890dc9fdbc9637e.svg";
export { ForwardRef as ReactComponent };